// extracted by mini-css-extract-plugin
export default {"highlightContainer":"Highlights_highlightContainer__W9oAo","highlightIcon":"Highlights_highlightIcon__j5Iqo","highlightContent":"Highlights_highlightContent__nTD8b"};